import {
  INIT_URL,
  USER_TOKEN_SET,
  USER_DATA,
  GET_LIST_VAI_TRO
} from 'src/constants/ActionTypes';

export const setInitUrl = (url) => ({
  type: INIT_URL,
  payload: url
});

export const setToken = (accessToken) => ({
  type: USER_TOKEN_SET,
  payload: accessToken
});

export const getUserInfo = () => ({
  type: USER_DATA
});

export const getListVaiTro = () => ({
  type: GET_LIST_VAI_TRO
});
